import { FC, CSSProperties } from 'react';
import Link from '@base/lib/ThemeLink';
import Iconfont from '@base/lib/Iconfont';
import { useTrans } from 'base/utils/i18n';

type IProps = {
    linkText?: string;
    link: string;
    linkIcon?: string;
    className?: string;
    style?: CSSProperties;
}


const ViewMoreCard: FC<IProps> = (props) => {
    const { t } = useTrans();
    const defaultText = t('web_common_view_more');

    const {
        linkText = defaultText,
        link,
        linkIcon,
        className,
        style
    } = props


    return (
        <Link href={link}>
            <a aria-label={linkText || defaultText} className={className} style={style}>
                <div className={'g-icon'}>
                    {linkIcon ? (
                        linkIcon
                    ) : (
                        <Iconfont className="icon-arrow-right"/>
                    )}
                </div>
                <div className={'g-text'}>
                    {linkText}
                </div>
            </a>
        </Link>
    );
};

export default ViewMoreCard